import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

import { SearchTextBox } from '@/components/search/searchTextBox';

import { type TagFilterMode } from './tagKeyValueUtils';

/**
 * The search row of a tags filter: one box per half of the tag the mode selects, plus an optional
 * trailing action. Only the two-box key-value mode needs to say which box is which.
 */
export const TagSearchBoxes = ({
  mode,
  keyFilter,
  valueFilter,
  onKeyFilterChange,
  onValueFilterChange,
  action,
}: {
  mode: TagFilterMode;
  keyFilter: string;
  valueFilter: string;
  onKeyFilterChange: (value: string) => void;
  onValueFilterChange: (value: string) => void;
  action?: ReactNode;
}) => {
  // Every mode filters on the key; only key-value adds a second box, and only then does either box
  // need to say which half it searches.
  const hasValueSearch = mode === 'key-value';

  return (
    <Stack
      direction='row'
      className='w-full'
      sx={{
        alignItems: 'center',
        gap: '12px',
      }}
    >
      <Stack
        sx={{
          gap: '12px',
          flexGrow: 1,
        }}
      >
        <SearchTextBox
          value={keyFilter}
          onChange={onKeyFilterChange}
          placeholder={hasValueSearch ? 'Search by key' : 'Search...'}
          autoFocus
        />
        {hasValueSearch && (
          <SearchTextBox
            value={valueFilter}
            onChange={onValueFilterChange}
            placeholder='Search by value'
          />
        )}
      </Stack>
      {action}
    </Stack>
  );
};
